<template>
    <div class="c-monthly-row c-monthly-footer"
        :data-component-name="$options.name"
    >
        <MoreFilters 
            @set-more-filters="$emit('set-more-filters', $event)"
        />
        <div class="c-monthly-cell -gap">
            <div class="c-monthly-footer__item -control -left">
                <RangePicker 
                    v-model="monthrange.str"
                    @set-current-date="$emit('set-current-date', $event)"
                    class="c-monthly-control -calendar -border-bottom"
                />
                <button
                    class="c-monthly-control -previous-week"
                    @click="$emit('set-current-date', prevMonth)"
                    ref="prevMonth"
                >
                    <SvgIcon name="arrow-alt-left" />
                </button>
            </div>
        </div>
        <div class="c-monthly-footer__item -full">
            <div
                class="c-monthly-cell"
                v-bind:key="index"
                v-for="(monthday, index) in monthdays"
                :class="{
                    '-new-month' : index==0 || monthdays[index-1].monthStr.full!=monthday.monthStr.full,
                    '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                    '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6
                }"
            >
                <span
                    class="c-monthly__monthname"
                    v-if="index==0 || monthdays[index-1].monthStr.full!=monthday.monthStr.full"
                    style="white-space: nowrap"
                >
                    {{ monthday.monthStr.full }} {{ monthday.date.getFullYear() }}
                </span>
                <span class="c-monthly-day__status">
                    <span class="o-status-pin" :class="monthday.summary.state" v-if="monthday.summary && monthday.summary.state!=''"><!-- STATUS CLASS .-draft,.-published,.-alert,.-confirmed,.-completed -->
                    </span>
                    <!-- {{monthday.summary.state}} -->
                </span>
                <span class="c-monthly-day" @click="$emit('set-current-date', monthday.dateStr)">{{ monthday.date.getDate() }}</span>
            </div>
        </div>
        <div class="c-monthly-cell -gap">
            <div class="c-monthly-footer__item -control -right">
                <RangePicker 
                    v-model="monthrange.str"
                    @set-current-date="$emit('set-current-date', $event)"
                    class="c-monthly-control -calendar -border-bottom"
                />
                <button
                    class="c-monthly-control -previous-week"
                    @click="$emit('set-current-date', nextMonth)"
                    ref="nextMonth"
                >
                    <SvgIcon name="arrow-alt-right" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    // import {getDatesBetween, getMonthLimits, dayOfWeekStr, monthStr, dayStr} from "@/js/dateUtilities"
    import moment from 'moment';
    import MoreFilters from '@/components/nav/MoreFilters'

    export default{
        name: 'MonthViewFooter',
        components: {
            MoreFilters
        },
        props: {
            currentDate: String,
            monthrange: Object,
            monthdays: Array,
        },
        data(){
            return {
                dateOffset: 0
            }
        },
        mounted(){
            document.onkeydown = function (e) {
                if (e.keyCode == 37 && e.altKey && e.ctrlKey && !e.shiftKey) this.$emit('set-current-date', this.prevMonth)
                if (e.keyCode == 39 && e.altKey && e.ctrlKey && !e.shiftKey) this.$emit('set-current-date', this.nextMonth)

                if (e.keyCode == 37 && e.altKey && e.ctrlKey && e.shiftKey) {
                    this.dateOffset--
                    this.$emit('set-current-date', moment(this.currentDate).subtract(1, 'days').format('YYYY-MM-DD'))
                    this.$emit('set-date-offset', this.dateOffset)
                }
                if (e.keyCode == 39 && e.altKey && e.ctrlKey && e.shiftKey) {
                    this.dateOffset++
                    // if (this.dateOffset > 30) {
                    //     this.dateOffset = 0
                    // }
                    this.$emit('set-current-date', moment(this.currentDate).add(1, 'days').format('YYYY-MM-DD'))
                    this.$emit('set-date-offset', this.dateOffset)
                }


            }.bind(this)
        },
        beforeDestroy() {
            document.onkeydown = null
        },
        computed: {
            prevMonth(){
                return moment(this.currentDate).subtract(1, 'months').format('YYYY-MM-DD');
            },
            nextMonth(){
                return moment(this.currentDate).add(1, 'months').format('YYYY-MM-DD');
            },
            // monthdays(){
            //     let monthrange=getMonthLimits(this.currentDate, 35, -7)
            //     let dateRange=getDatesBetween(monthrange.obj.from, monthrange.obj.to)
            //     let monthdays=[]

            //     dateRange.forEach(function(date){
            //         monthdays.push({
            //             date: date,
            //             day: dayStr(date.getDate()),
            //             dayOfWeekStr: dayOfWeekStr(date),
            //             monthStr: monthStr(date)
            //         })
            //     })
            //     return monthdays
            // },
        }
    }
</script>